import { CharacterCardVariant } from "@next-platform/client-common-spicy-ui";
import { ModerationStatus, Rulebook, RulebookStatus, RulebookVisibility } from "@next-platform/packages-ts-types";

/** The four fields the badge needs — callers pass a full Rulebook or a normalised profile. */
type RulebookVariantFields = Partial<Pick<Rulebook, "visibility" | "status" | "moderation_status" | "moderation_report_status">>;

/** Open-report / moderation states override the visibility badge, same precedence as getLorebookVariant. */
const moderationVariant = (rulebook: RulebookVariantFields): CharacterCardVariant | undefined => {
  const moderationStatus = rulebook?.moderation_report_status ?? rulebook?.moderation_status;
  if (moderationStatus === ModerationStatus.FixRequired) {
    return CharacterCardVariant.ACTION;
  }
  if (moderationStatus === ModerationStatus.Pending || moderationStatus === ModerationStatus.RereviewRequired) {
    return CharacterCardVariant.REVIEW;
  }
  if (rulebook?.status === RulebookStatus.IN_MODERATION || rulebook?.status === RulebookStatus.MODERATION_FAILED) {
    return CharacterCardVariant.NEEDS_REVIEW;
  }
  return undefined;
};

/** Card badge variant for a Rulebook — permanently-private reads as private since it is never public. */
const getRulebookVariant = (rulebook: RulebookVariantFields) => {
  const resolvedVisibility = rulebook?.visibility === RulebookVisibility.PERMANENTLY_PRIVATE ? RulebookVisibility.PRIVATE : rulebook?.visibility;

  const visibilityVariant = resolvedVisibility
    ? (CharacterCardVariant[resolvedVisibility.toUpperCase() as keyof typeof CharacterCardVariant] ?? CharacterCardVariant.DEFAULT)
    : CharacterCardVariant.DEFAULT;

  return moderationVariant(rulebook) ?? visibilityVariant;
};

export default getRulebookVariant;
